"use client"

import React from 'react';
import styles from "./Infos.module.css"
import {Path} from "@/types/Paths";
import {Segment} from "@/types/Segments";
import {useBuildInfo} from "@/utils/hooks/useBuildInfo";
import {Info as InfoType} from "@/types/Infos";
import Info from "@/components/Infos/Info";
import {GiAngelOutfit, GiOpenBook} from "react-icons/gi";
import {Chip} from "@mui/material";
import {Link} from "@/i18n/routing";

export default function Infos(props: { data: Path | Segment, className?: string, iconSize?: number }) {
  const infos = useBuildInfo(props.data, props.iconSize)
  return <div className={styles.infoWrapper + ' ' + props.className}>
    {infos?.map((info: InfoType, i: number) => {
      if (!info) return null
      return <Info info={info} key={i}/>
    })}
    {'saints' in props.data && props.data.saints && props.data.saints.map((itm, key) => {
      return (<Link
        key={key}
        href={`/pray?saint=${itm.id}`}>
        <Chip icon={<GiAngelOutfit/>} size={"small"}
              label={itm.name}
              color="primary"
              variant="outlined"/>
      </Link>)
    })
    }
    {'readings' in props.data && props.data.readings && props.data.readings.map((itm, key) => {
      return (<Link
        key={key}
        href={`/pray?reading=${itm.id}`}>
        <Chip icon={<GiOpenBook/>} size={"small"}
              label={itm.name}
              color="primary"
              variant="outlined"/>
      </Link>)
    })
    }
  </div>
}
